import _ from "lodash";
import ThemedBlock from "components/atoms/ThemedBlock";
import Timeslot from "components/molecules/Timeslot";
import { StyleSheet, View } from "react-native";
import React, { useEffect, useState } from "react";
import ListItem from 'theme/ListItem';
import { listStyles } from "styles/list";
import ThemedList from 'components/atoms/ThemedList'
import { ThemedSizes } from 'styles/themed'
import i18n from 'utils/i18n'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'
import EmployeeCard, { EmployeeCardModes } from "components/molecules/EmployeeCard";
import HelperString from 'utils/helper-string'
import TextDivider from 'components/atoms/TextDivider'
import ThemedSelect from 'components/atoms/ThemedSelect'
import { bookingStatus } from 'utils/constants/booking-constants'
import DataItemStatus from 'components/molecules/DataItemStatus'


const InvitationBookings = ({ bookingsByDate = {}, organizer = {}, employees = {}, selectable, onPressEmployee, overwriteEmployeeStatus = {}, editing = false }) => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const [ componentKey, setComponentKey ] = useState( HelperString.random() )
	
	const selectStatusOptions = _.map([ bookingStatus.INVITED, bookingStatus.INVITE_ACCEPTED, bookingStatus.INVITE_REJECTED ], status => {
		return {
			value: status,
			label: i18n.t(`page.booking.status.${status}` )
		}
	})
	
	const onStatusSelect = ( bookingGuid, employeeGuid, status ) => {
		if( _.isFunction( onPressEmployee ) ) {
			onPressEmployee( bookingGuid, employeeGuid, status );
		}
	}
	
	const RenderItemShow = ( item ) => {
		const { employee_guid, booking_guid } = item;
		let { status } = item;
		
		if( _.get( overwriteEmployeeStatus, booking_guid, null ) !== null ) {
			status = overwriteEmployeeStatus[ booking_guid ];
		}
		
		if( editing ) {
			return (
				<ThemedSelect
					placeholder={ false }
					options={ selectStatusOptions }
					selected={ status }
					select={ onStatusSelect.bind( this, booking_guid, employee_guid ) }
				/>
			)
		}
		
		return (
			<DataItemStatus>
				{ status }
			</DataItemStatus>
		)
	}
	
	const RenderItem = ({ item }) => {
		const { employee_guid } = item;
		const employee = _.get( employees, employee_guid, {} );
		
		let employeeName = employee.guid === _employee.guid ? i18n.t('basic.you') : employee.name;
		if( employeeName === null || HelperString.isEmptyString( employeeName ) ) {
			employeeName = employee.email
		}
		
		return (
			<ListItem
				key={ HelperString.hash('render-item-booking-item', item )}
				disabled={ true }
				style={ styles.listItem }>
			
				<View
					style={ [
						listStyles.iconContainer,
						styles.iconContainer,
					] }>
					
					<EmployeeCard
						mode={ EmployeeCardModes.listItem }
						employee={{
							...employee,
							name: employeeName
						}}
						show={ RenderItemShow.bind( this, item ) }
						avatarSize={ ThemedSizes.S }
						avatarShowIconEro={ false }
						avatarShowIconConfidant={ false }
						showHeart={ false }
					/>
				</View>
			</ListItem>
		)
	}
	
	let calendarListItemProps = {
		isViewingInvitation: true,
		showEmployeeElement: false,
		showAcceptedOnly: false,
		showLunchOptions: false,
		showBuildingParkingSpace: false
	}
	
	const employeeListElementStyle = [
		styles.employeeListElement
	];
	
	if( selectable === true ) {
		calendarListItemProps = {
			...calendarListItemProps,
			showEmployeeElement: false,
			showEmployee: true,
			showCapacity: false,
			selectable: 'checkbox',
			selectableDisabled: false
		}
		
		employeeListElementStyle.push( styles.employeeListElementSelectable );
	}
	
	// Force a new render
	useEffect( setComponentKey.bind( this, HelperString.random() ), [ editing, overwriteEmployeeStatus ] )
	
	return (
		_.map( bookingsByDate, ( section ) => {
			return (
				<View
					key={ HelperString.hash('invitation-booking-item', section.title )}>

					<TextDivider
						rowStyle={ styles.textDividerMarginTop12 }
						text={ section.title }
					/>

					<ThemedBlock
						shadow
						key={ HelperString.hash( `building-block-${componentKey}`, section.title ) }>

						{ _.map( section.booking, (item, bookingKey) => {
							const data = _.get( section.data, bookingKey, {} );
							if( _.isEmpty( data ) ) {
								return null;
							}

							// Sort them by the status as below
							const employeeList = {
								[ bookingStatus.INVITE_ACCEPTED ]: [],
								[ bookingStatus.INVITE_REJECTED ]: [],
								[ bookingStatus.INVITED ]: [],
							};

							_.forEach( data, (employees, status) => {
								_.forEach( employees, employee => {
									if( _.get( overwriteEmployeeStatus, employee.guid, null ) !== null ) {
										status = overwriteEmployeeStatus[ employee.guid ];
									}

									employeeList[ status ].push({
										...employee,
										status: status
									});
								})
							})

							// Add then combine them all to one list
							const finalList = [];
							_.forEach( employeeList, o => {
								_.forEach( o, oo => {
									finalList.push( oo )
								})
							})

							return (
								<Timeslot
									key={ HelperString.hash('calendar-list-booking', item )}
									item={ item }
									itemProps={ calendarListItemProps }>

									<View
										style={ employeeListElementStyle }>

										<ThemedList
											key={ HelperString.hash('calendar-list-booking-list', item )}
											style={ styles.themedListPaddingHorizontal0MarginLeft }
											data={ finalList }
											renderItem={ RenderItem.bind( this ) }
											scrollEnabled={ false }
										/>
									</View>
								</Timeslot>
							)
						})}
					</ThemedBlock>
				</View>
			);
		})
	)
}

export default InvitationBookings

const styles = StyleSheet.create({
	textDividerMarginTop12: {
		marginTop: 12,
	},
	themedListPaddingHorizontal0MarginLeft: {
		paddingHorizontal: 0,
		marginLeft: -4,
	},
	employeeListElement: {
		width: '100%',
	},
	
	employeeListElementSelectable: {
		width: '100%',
		paddingTop: 12
	},
	
	listItem: {
		paddingVertical: 2,
		paddingHorizontal: 2,
		flex: 1,
	},
	listItemRow: {
		flex: 1,
		flexDirection: 'column',
		flexGrow: 1,
	},
	listItemAvatar: {
		justifyContent: 'flex-start',
		alignItems: "flex-start",
	},
	listItemContent: {
		marginTop: 5,
		flexGrow: 1
	},
	
	iconContainer: {
		flex: 1,
	}
});
